import { FC, useEffect, useState } from 'react';
import EmbeddingForm from '../../components/EmbeddingForm';
import { WidgetConfigProps } from '../../components/EmbeddingForm/types';
import EmbeddingModeTab from '../../components/EmbeddingModeTab';
import EmbeddingSideTab from '../../components/EmbeddingSideTab';
import { EmbeddingProps } from './interface';
import './style.scss';
import { getEmbedForm } from '../../Services/API';

const Embedding: FC<EmbeddingProps> = ({ editUUID, formUUID, previewType, shareMode }) => {

  const [widgetConfigDetails, setWidgetConfigDetails] = useState<WidgetConfigProps>({
    mode: "standard-screen",
    width: "100%",
    height: "auto",
    formId: formUUID,
  })
  const [selectedEmbed, setSelectedEmbed] = useState<any>({});
  const [embedResponse, setEmbedResponse] = useState<any>([])
  const [alertOpen, setAlertOpener] = useState<boolean>(false);
  const fetchEmbed = async () => {
    try {
      const response = await getEmbedForm(editUUID);
      if (response?.data) {
        setEmbedResponse(response?.data);
      }
    } catch (error) {
      console.error("GET embed error:", error);
    }
  };
useEffect(() => {
  setWidgetConfigDetails((prev) => ({
    ...prev
   
  }));
}, [previewType]);

  return (
    <div className="embeddingFormContainer">
      <EmbeddingSideTab setWidgetConfigDetails={setWidgetConfigDetails} widgetConfigDetails={widgetConfigDetails} formId={formUUID || ""} editUUID={editUUID} selectedEmbed={selectedEmbed} setSelectedEmbed={setSelectedEmbed} embedResponse={embedResponse} fetchEmbed={fetchEmbed} shareMode={shareMode} />
      <EmbeddingForm config={widgetConfigDetails} formId={formUUID || ""} previewType={previewType} />
      <EmbeddingModeTab editUUID={editUUID} widgetConfigDetails={widgetConfigDetails} setWidgetConfigDetails={setWidgetConfigDetails} selectedEmbed={selectedEmbed} embedResponse={embedResponse} fetchEmbed={fetchEmbed} alertOpen={alertOpen} setAlertOpener={setAlertOpener} />
    </div>
  )
}
export default Embedding